import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDMMy_jSxbTovuqQgevGtoJy0bosy-wbtw",
  authDomain: "ksdpl-app-v2.firebaseapp.com",
  projectId: "ksdpl-app-v2",
  storageBucket: "ksdpl-app-v2.firebasestorage.app",
  messagingSenderId: "472630572477",
  appId: "1:472630572477:web:f20e52a55cc483b6814ed4",
  measurementId: "G-KNP86WR0PS",
};

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);
